import { render, staticRenderFns } from "./EstateAgentAddress.vue?vue&type=template&id=47009190"
import script from "./EstateAgentAddress.vue?vue&type=script&lang=js"
export * from "./EstateAgentAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports